export default (elem, options) => {
  if (!options.parent || !elem) {
    return;
  }

  const appendToParent = (parent) => {
    if (!parent) {
      console.error("Elemento pai não encontrado.");
      return;
    }

    if (options.append === 'after') {
      parent.after(elem);
    } else if (options.append === 'before') {
      parent.before(elem);
    } else if (options.append === 'first') {
      parent.prepend(elem);
    } else {
      parent.append(elem);
    }
  };

  if (options.parent instanceof Promise) {
    options.parent
      .then((parent) => appendToParent(parent))
      .catch((error) => {
        console.error("Erro ao resolver o parent:", error);
      });
    return;
  }

  if (options.parent instanceof Element) {
    appendToParent(options.parent);
    return;
  }

  if (typeof options.parent === 'string') {
    appendToParent(document.querySelector(options.parent));
  }
};
